import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-52573dc0"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "wrapper ml20 p20"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane");
  const _component_el_tabs = _resolveComponent("el-tabs");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_tabs, null, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.comps, (item, index) => {
      return _openBlock(), _createBlock(_component_el_tab_pane, {
        key: index,
        label: item.label,
        name: index.toString()
      }, {
        default: _withCtx(() => [(_openBlock(), _createBlock(_resolveDynamicComponent(item.name)))]),
        _: 2
      }, 1032, ["label", "name"]);
    }), 128))]),
    _: 1
  })]);
}